import { GlobalState } from "@/types/store/clientzone/global";
import { BusinessTypes, TimezoneData } from "@/types";

export const state: GlobalState = {
  businessTypes: [] as Array<BusinessTypes>,
  timezones: [] as Array<TimezoneData>
}
